import Playing from '@pages/playing/playing';
export default Playing;
